// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_4e5f713ae4--carousel--XHqt9"};